import "./Divider.css";

import type { SizeProp } from "../components";

export interface DividerProps {
  orientation?: "vertical" | "horizontal";
  size?: Extract<SizeProp, "sm" | "md" | "lg">;
}

export function Divider({
  size = "md",
  orientation = "horizontal",
}: DividerProps) {
  return (
    <div className="Divider" data-orientation={orientation} data-size={size} />
  );
}
